export enum PerformanceRating {
   Strength,
   Weakness,
   Unknown,
   'No Value',
}
